import { useEffect, useState } from 'react';

// The site header is fixed at the top (HeaderNew always; the legacy Header's .cm_header once the
// page scrolls), and its height changes as it wraps. The pinned summary sits right under it and
// shows once the summary cards have scrolled up behind it.
//
// Under the header's visible parts, not its box: main.css gives every <header> a 113px min-height,
// taller than HeaderNew's top bar and nav, so the box ends about 11px below the nav in a transparent
// strip the page shows through. Hidden parts (the top bar on small screens) measure 0.
const headerEl = () => document.querySelector('.cm_header') || document.querySelector('header');
const headerParts = el => (el.children.length ? [...el.children] : [el]);
const headerBottom = () => {
  const el = headerEl();
  if (!el) return 0;
  const bottom = Math.max(...headerParts(el).map(part => part.getBoundingClientRect().bottom));
  return Math.max(0, Math.round(bottom));
};

export function usePinnedSummary(summaryRef) {
  const [state, setState] = useState({ visible: false, top: 0 });

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const el = summaryRef.current;
      const top = headerBottom();
      const visible = Boolean(el) && el.getBoundingClientRect().bottom < top;
      setState(prev => (prev.visible === visible && prev.top === top ? prev : { visible, top }));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [summaryRef]);

  return state;
}
